import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
	[theme.breakpoints.down('sm')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'15px',
			minWidth:'15px'
		},
	},
	[theme.breakpoints.up('md')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
	},
	setoverflow:{
		overflow:'hidden',
		display: 'block'
	}
});

class BillingOrderRow extends Component {
	constructor(props) {
        super(props);
		this.click = this.click.bind(this);
		this.analiticAccountColumn = this.analiticAccountColumn.bind(this);
		this.referenceColumn = this.referenceColumn.bind(this);
		this.userColumn = this.userColumn.bind(this);
    }
	
	click(){
		this.props.desplega(this.props.index);
	}
	userColumn(){
		if(this.props.role=='CUSTOMER'){
			return <TableCell></TableCell>
		}else{
			return "";
		}
	}
	referenceColumn(){
		if(this.props.printReference){
			return <TableCell></TableCell>
		}else{
			return "";
		}
	}
	analiticAccountColumn(){
		if(this.props.role=='CUSTOMER'){
			return "";
		}else{
			return <TableCell></TableCell>
		}
	}
	
	render() {
		return (
			<TableRow hover key={"o_"+this.props.id} style={{background: '#c1ceff'}} onClick={this.click}>
				<TableCell className={this.props.classes.smallcell}>{this.props.code}</TableCell>
				{this.userColumn()}
		        <TableCell></TableCell>
				<TableCell></TableCell>
				{this.referenceColumn()}
				{this.analiticAccountColumn()}
				<TableCell>{new Intl.DateTimeFormat('es-ES', {year: 'numeric', month: 'numeric', day: 'numeric'}).format(new Date(this.props.date))}</TableCell>
				<TableCell className={this.props.classes.smallcell}></TableCell>
				<TableCell className={this.props.classes.smallcell}></TableCell>
				<TableCell className={this.props.classes.smallcell}></TableCell>
				<TableCell className={this.props.classes.smallcell}>{this.props.total} €</TableCell>
			</TableRow>
		);
	}
}
export default withStyles(styles)(BillingOrderRow);